<template>
  <div>
    <div>
      <div class="d-flex w-100 justify-content-between align-items-center">
        <h1 class="labelBold">
          {{ this.$t(`qrAccess.reports.title`) }}
        </h1>
      </div>
      <div class="my-3">
        <label for="types">{{ this.$t(`qrAccess.reports.reportType`) }}</label>
        <br>
        <label for="types">{{ this.$t(`qrAccess.reports.notifyEmail`) }}</label>
        <div class="row px-3" id="types">
          <button
            v-for="i in buttons"
            :key="i.label"
            :class="[
              i.value === type.value
                ? 'btn btn-secondary mx-1'
                : 'btn btn-dark mx-1',
            ]"
            @click="() => setType(i.value)"
          >
            {{ i.label }}
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-4">
          <label for="start">
            {{ `${this.$t(`qrAccess.reports.start`)} 00:00 Hrs` }}
          </label>
          <div id="start" class="date-row">
            <date-picker
              v-model="dates.start"
              valueType="YYYY/MM/DD"
              class="w-full"
            ></date-picker>
          </div>
        </div>
        <div class="col-md-4">
          <label for="start">
            {{ `${this.$t(`qrAccess.reports.end`)} 23:59 Hrs` }}
          </label>
          <div id="end" class="date-row">
            <date-picker
              v-model="dates.end"
              valueType="YYYY/MM/DD"
              class="w-full"
            ></date-picker>
          </div>
        </div>
        <div class="col-md-4 align-self-center">
          <div class="date-row mt-4 ml-2 text-center">
            <button
              class="btn btn-dark"
              :disabled="this.type.value.length === 0"
              @click="validateData"
            >
              {{ this.$t("qrAccess.reports.generate") }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4"></div>
    </div>
    <div v-if="ErrorMsg.show" class="error-msg my-2">
      {{
        ErrorMsg.type === "date"
          ? $t("qrAccess.reports.dateError")
          : $t("qrAccess.reports.dateError")
      }}
    </div>
    <div v-if="SuccessMsg.show" class="msg my-2">
      {{ `${$t("qrAccess.reports.successReport")} ${SuccessMsg.email}` }}
    </div>
        <b-modal size="lg" centered ref="my-info" hide-footer  scrollable  tabindex="-1" >
         <center>
         <i style="font-size:60px; color:green" class="fa">&#xf058;</i>
         <div v-if="appLang =='es'">
         <strong>
              El correo con la liga lo recibirás en un tiempo aproximado
              <br/>
               de 15 minutos.
               <br/>
               <br/>
                Te pedimos esperar este tiempo para generar otra  
               <br/>
                solicitud.
                </strong>
            </div>
                <div v-if="appLang =='en'">
                  <strong>
                  You will receive the mail with the link in an approximate time
                  <br/>
                    of 15 minutes.
                    <br/>
                    <br/>
                    We ask you to wait this time to generate another
                    <br/>
                    request.
                    </strong>
                </div>
                  <br/>
                    <div class="col-md-2">
                           <button class="btn btn-dark mx-1" @click="Close()"> {{ $t("qrAccess.reports.close") }}</button>
                        </div> 
        </center>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import API_SERVICE from "@/lib/api/QRAccess.js";
const api = new API_SERVICE();
const Alert = import("@/components/alerts/Alert");
export default {
  components: {
    Alert,
    DatePicker,
  },

  
  data: function () {
    return {
      dates: {
        start: null,
        end: null,
      },
      buttons: [
        {
          label: this.$t("qrAccess.reports.tabs.drivers"),
          value: "drivers",
        },
        {
          label: this.$t("qrAccess.reports.tabs.travels"),
          value: "travels",
        },
        {
          label: this.$t("qrAccess.reports.tabs.billing"),
          value: "billing",
        },
      ],
      type: {
        value: "",
      },
      ErrorMsg: {
        show: false,
        type: "",
      },
      SuccessMsg: {
        show: false,
        email: "",
      },
    };
  },
    computed: {
    appLang: function () {
      return this.$store.getters["settings/currentLang"];
    }
    },

  methods: {
      showInf: function(){
      this.$refs['my-info'].show();
    },
     Close: function(){
      this.$refs['my-info'].hide();
    },
    setType: function (value) {
      this.type.value = value;
    },
    validateData: function () {
      if (this.ErrorMsg.show) this.ErrorMsg.show = false;
      if (this.type.value.length === 0) return null;

      this.generateReport();
    },
    generateReport: async function () {
      try {
        this.$store.commit("global/SET_LOADING", true);
      
        const getDate = (type = "start") => {
          const time = type === "start" ? "00:00" : "23:59";
          return `${this.dates[type]} ${time}`;
        };
        const params = {
          type: this.type.value,
          start: getDate("start"),
          end: getDate("end"),
        };
        await api.getQrReports(params);
        this.$store.commit("global/SET_LOADING", false);
        this.showInf();
        this.SuccessMsg.show = true;
        this.SuccessMsg.email = this.$store.getters["session/emailAdmin"];
        return;
      } catch (error) {
        this.ErrorMsg.show = true;
        this.ErrorMsg.type = "server";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-msg {
  padding: 1rem 0;
  color: $warn_red;
  font-weight: bold;
}
.msg {
  padding: 1rem 0;
  color: $warn_green;
  font-weight: bold;
}
.btn {
  border: none;
  border-radius: 0px;
}
.date-row {
  width: 100%;
  display: flex;
}
.w-full {
  width: 100%;
}
</style>